// Vuetify validation rules for <script setup> forms (same messages as the
// legacy formRules mixin). Each returns true or an error message.

const isBlank = (v) => v === null || v === undefined || String(v).trim() === '';

export const required = (v) =>
  (Array.isArray(v) ? v.length > 0 : !isBlank(v)) || 'This field is required.';

export const email = (v) =>
  isBlank(v) ||
  /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/.test(v) ||
  'Enter a valid email address.';

export const strongPassword = (v) =>
  isBlank(v) ||
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/.test(v) ||
  'At least 8 characters with an uppercase letter, a lowercase letter, a number and a symbol.';

// Usage: :rules="[required, matches(() => form.password, 'Passwords do not match.')]"
export const matches = (getOther, message = 'Values do not match.') => (v) =>
  isBlank(v) || v === getOther() || message;
